<template>
  <!-- 底部转化与联系信息区 -->
  <footer class="footer">
    <div class="container_2026">
      <!-- 转化按钮区 -->
      <div class="cta-buttons">

        <div class="buttons">
          <a href="https://www.cyberway.net.cn/contact" target="_blank" class="cta-button">AI 咨询</a>
          <a href="https://www.cyberway.net.cn/contact" target="_blank" class="cta-button">AI 标准化产品免费试用</a>
          <a href="https://www.cyberway.net.cn/contact" target="_blank" class="cta-button">企业业务 AI 化升级方案演示</a>
        </div>
      </div>

      <div class="footer-content">
        <!-- 联系信息区 -->
        <div class="contact-info">
          <h3>联系我们</h3>
          <div class="contact-section">
            <p class="contact-title">产品咨询</p>
            <p class="contact-value"><span class="highlight">400-168-0262</span></p>
          </div>
          <div class="contact-section">
            <p class="contact-title">市场合作</p>
            <p class="contact-value">020-82108862</p>
          </div>
          <div class="contact-section">
            <p class="contact-title">合作邮箱</p>
            <p class="contact-value">Marketing@cyberway.net.cn</p>
          </div>
        </div>

        <!-- 新媒体二维码区 -->
        <div class="social-qr">
          <p>AI 产品动态、行业干货实时更新</p>
          <div class="qr-codes">
            <div class="qr-code">
            <p>官方公众号</p>
            <img src="../assets/img/images/images3.jpg" alt="公众号二维码" class="qr-image">
          </div>
          <div class="qr-code">
            <p>官方视频号</p>
            <img src="../assets/img/images/images4.jpg" alt="视频号二维码" class="qr-image">
          </div>
          <div class="qr-code">
            <p>官方企微</p>
            <img src="../assets/img/images/images5.png" alt="企微二维码" class="qr-image">
          </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-box">
      <div class="center">
        <div class="left-box">
          <img v-lazy="require('@/assets/img/logo/logo-w.png')" alt="赛博威" />
          <span>©2002-2026 广东赛博威信息科技有限公司版权所有，侵权必究！</span>
        </div>
        <!--cyberway.com.cn 开始 -->
        <div class="right-box">
          <div class="txt txt1" @click="jumpTo('https://beian.miit.gov.cn')">粤ICP备17158128号-12</div>
          <div class="txt" @click="jumpTo('https://beian.mps.gov.cn/#/query/webSearch?code=44011202002759')">
            <img v-lazy="require('@/assets/img/footer/icon.png')" />粤公网安备44011202002759号

          </div>
        </div>
        <!--cyberway.com.cn 结束 -->
        <!--cyberway.net.cn 开始 -->
        <!-- <div class="right-box">
          <a href="https://beian.miit.gov.cn" target="_blank">
            <div class="txt txt1" @click="jumpTo('https://beian.miit.gov.cn')">粤ICP备17158128号</div>
          </a>
          <div class="txt" @click="jumpTo('https://beian.mps.gov.cn/#/query/webSearch?code=44011202001029')">
            <img v-lazy="require('@/assets/img/footer/icon.png')" />粤公网安备案
            44011202001029号
          </div>
        </div> -->
        <!--cyberway.net.cn 结束 -->
      </div>
    </div>

  </footer>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  methods: {
    jumpTo(url) {
      window.open(url);
    }
  }
};
</script>

<style scoped>
.footer .container_2026 {
  width: 100%;
  max-width: 1360px;
  margin: 0 auto;
  padding-left: 12px;
  padding-right: 12px;
  box-sizing: border-box;
}

</style>
<style scoped lang="scss">
.bottom-box {
    width: 100%;
    //height: 106px;
    padding: 0 165px 0 183px;
    box-sizing: border-box;
    //background-color: #191c21;
    // position: absolute;
    // bottom: 0;
    // left: 0;
    .center {
      width: 100%;
      height: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .left-box {
      display: flex;
      align-items: center;
      justify-content: space-between;

      img {
        width: auto;
        height: 38px;
        margin-top: -10px;
        margin-right: 30px;
      }
      span {
        font-size: 18px;
        color: #bcbcbc;
        font-family: "MiSans-Regular-";
      }
    }
    .right-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-left: auto;

      a {
        // 禁用下划线
        text-decoration: none;
      }
      .txt {
        font-size: 18px;
        color: #bcbcbc;
        font-family: "MiSans-Regular-";
        display: flex;
        align-items: center;
        cursor: pointer;
        &:hover {
            color: #fff;
          }
        img {
          width: 16px;
          height: 18px;
          margin-right: 4px;
        }
      }
      .txt1 {
        margin-right: 95px;
      }
    }
  }
  .friend-link {
    width: 100%;
    background-color: #00094c;
    position: absolute;
    bottom: 0;
    font-size: 15px;
    font-family: "MiSans-Demibold-";
    color: #ffffff;
    line-height: 31px;
  }


    </style>



// WEBPACK FOOTER //
// src/components/Footer.vue